import { syncDirtyBudgets } from "containers/Budget/_actions";
import { push } from "connected-react-router";
import ReactGA from "react-ga4";

const actionTypes = {
    EFFLUENT_SYSTEM_SUBMIT: "EFFLUENT_SYSTEM_SUBMIT",
    EFFLUENT_SYSTEM_DELETE: "EFFLUENT_SYSTEM_DELETE",
    EFFLUENT_STRUCTURE_SUBMIT: "EFFLUENT_STUCTURE_SUBMIT",
    EFFLUENT_STRUCTURE_DELETE: "EFFLUENT_STUCTURE_DELETE",
    EFFLUENT_SAVE_OUTDOOR_PIG_EFFLUENT_SYSTEM: "EFFLUENT_SAVE_OUTDOOR_PIG_EFFLUENT_SYSTEM",
};
export default actionTypes;

export function submitSystem(farmId, budgetId, effluentSystem, structureId) {
    ReactGA.event({
        category: "Effluent System",
        action: "Save",
    });
    return (dispatch) => {
        dispatch({ type: actionTypes.EFFLUENT_SYSTEM_SUBMIT, payload: { farmId: farmId, budgetId: budgetId, effluentSystem: effluentSystem, structureId: structureId } });
        dispatch(syncDirtyBudgets(budgetId));
    };
}

export function deleteSystem(farmId, budgetId) {
    ReactGA.event({
        category: "Effluent System",
        action: "Delete",
    });
    return (dispatch) => {
        dispatch({ type: actionTypes.EFFLUENT_SYSTEM_DELETE, payload: { farmId: farmId, budgetId: budgetId } });
        dispatch(push(`/app/farm/${farmId}/analysis/${budgetId}/structures`));
        dispatch(syncDirtyBudgets(budgetId));
    };
}

export function saveOutdoorPigEffluentSystem(farmId, budgetId, outdoorPigEffluentSystem) {
    ReactGA.event({
        category: "Outdoor Pig Effluent System",
        action: "Save",
    });
    return (dispatch) => {
        dispatch({ type: actionTypes.EFFLUENT_SAVE_OUTDOOR_PIG_EFFLUENT_SYSTEM, payload: { farmId, budgetId, outdoorPigEffluentSystem } });
        dispatch(syncDirtyBudgets(budgetId));
    };
}

export function submitStructure(farmId, budgetId, structure) {
    ReactGA.event({
        category: "Structure",
        action: "Save",
    });
    return (dispatch) => {
        dispatch({ type: actionTypes.EFFLUENT_STRUCTURE_SUBMIT, payload: { farmId: farmId, budgetId: budgetId, structure: structure } });
        dispatch(syncDirtyBudgets(budgetId));
    };
}

export function deleteStructure(farmId, budgetId, id) {
    ReactGA.event({
        category: "Structure",
        action: "Delete",
    });
    return (dispatch) => {
        dispatch({ type: actionTypes.EFFLUENT_STRUCTURE_DELETE, payload: { farmId: farmId, budgetId: budgetId, id: id } });
        dispatch(syncDirtyBudgets(budgetId));
    };
}
